import React from 'react';
import { openNewWindow, setDash, setDetailPageUrl } from '../../../../lib/common';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import OpenCouponDetail from '../../../../components/link/OpenCouponDetail';
import TableFilterSelect from '../../../../components/_table/TableFilterSelect';
import CouponBenefit from '../../common/CouponBenefit';
import CouponBenefitInfo from '../../common/CouponBenefitInfo';
import { setDateFormat } from '../../../../lib/moment';
import CouponPeriod from '../../common/CouponPeriod';
import Anchor from '../../../../components/link/Anchor';
import { setCouponGenerateLimitCount } from '../../../../lib/utils/couponUtils';
import OpenOrderItemDetail from '../../../../components/link/OpenOrderItemDetail';
import {
  COUPON_AVAILABLE_TYPE_TEXT,
  COUPON_IS_USED_TYPE_SELECT_LIST,
  COUPON_IS_USED_TYPE_TEXT,
} from '../../../../constants/service/app/couponConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { ACCOUNT_USER_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { ACCOUNT_USER_DETAIL_TAB_KEY } from '../../../../constants/service/app/accountUserConstants';

/**
 *  쿠폰 발급 내역에 연결된 쿠폰 발급 내역 아이템 리스트 컬럼
 */
export const columns = (props) => {
  const { filterOption, sortOption, onFilter, isFilter } = props;

  return [
    {
      title: <TableColumnTitle title={'회원 번호'} />,
      dataIndex: 'userId',
      sorter: isFilter,
      sortOrder: sortOption['userId'],
      render: (value) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() =>
            openNewWindow(
              setDetailPageUrl(ACCOUNT_USER_DETAIL_URL_PATH, value) +
                `?tabKey=${ACCOUNT_USER_DETAIL_TAB_KEY.COUPON_INFO}`,
            )
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'이름'} />,
      dataIndex: 'userName',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'쿠폰 번호'} />,
      sortOrder: sortOption['couponId'],
      sorter: isFilter,
      dataIndex: 'couponId',
      render: (value) => <OpenCouponDetail text={value} couponId={value} />,
    },
    {
      title: <TableColumnTitle title={'사용 여부'} filterValue={COUPON_IS_USED_TYPE_TEXT[filterOption.isUsed]} />,
      dataIndex: 'isUsed',
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={COUPON_IS_USED_TYPE_SELECT_LIST}
          option={filterOption.isUsed}
          confirm={confirm}
          onFilter={(isUsed) => onFilter({ isUsed })}
        />
      ),
      render: (value) => COUPON_IS_USED_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'쿠폰 이름'} />,
      dataIndex: 'couponName',
    },
    {
      title: <TableColumnTitle title={'쿠폰 설명'} />,
      dataIndex: 'description',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'쿠폰 혜택'} />,
      dataIndex: 'discountType',
      render: (value, record) => <CouponBenefit type={value} amount={record.discountAmount} />,
    },
    {
      title: <TableColumnTitle title={'쿠폰 유형'} />,
      dataIndex: 'availableType',
      render: (value) => COUPON_AVAILABLE_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'입력 코드'} />,
      dataIndex: 'code',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'제한 횟수'} />,
      dataIndex: 'generateLimitCount',
      render: (value, record) => setCouponGenerateLimitCount(record.generateLimitDay, value),
    },
    {
      title: <TableColumnTitle title={'쿠폰 혜택 정보'} />,
      render: (value, record) => (
        <CouponBenefitInfo
          type={record.discountType}
          amount={record.discountAmount}
          minimumPurchasePrice={record.minimumPurchasePrice}
          maxDiscountPrice={record.maxDiscountPrice}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'발급일자'} />,
      dataIndex: 'issuedDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
    {
      title: <TableColumnTitle title={'사용기간'} />,
      render: (value, record) => (
        <CouponPeriod
          type={record.periodType}
          startDate={record.startDate}
          endDate={record.endDate}
          dayPlus={record.dayPlus}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'메모'} />,
      dataIndex: 'memo',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'사용일자'} />,
      dataIndex: 'useDate',
      render: (value) => setDash(setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT)),
    },
    {
      title: <TableColumnTitle title={'상품 주문번호'} />,
      dataIndex: 'orderItemId',
      render: (value) => <OpenOrderItemDetail text={value} orderItemId={value} />,
    },
    {
      title: <TableColumnTitle title={'총 주문금액'} />,
      dataIndex: 'orderPrice',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'수량'} />,
      dataIndex: 'quantity',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'포인트 할인 금액'} />,
      dataIndex: 'usedPoint',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'쿠폰 할인 금액'} />,
      dataIndex: 'usedCouponPrice',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'실제 결제 금액'} />,
      dataIndex: 'totalPrice',
      render: (value) => setDash(value),
    },
  ];
};
